import { render, staticRenderFns } from "./widget_reg.vue?vue&type=template&id=37247cc4&scoped=true"
import script from "./widget_reg.vue?vue&type=script&lang=js"
export * from "./widget_reg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37247cc4",
  null
  
)

export default component.exports